howspace.widgets.webinar = (() => {
    'use strict';

    const livePopoutLayout = $('.live-popout-layout');

    // Whereby iframe message event.
    window.addEventListener('message', function(event) {
        if (event.origin !== real.dom.$html.data('whereby-uri')) {
            return;
        }

        if (event.data.type === 'people_toggle') {
            $('.live-popout-webinar-actions').toggleClass('hidden');
        }
    });

    real.events.on('uploadedfile:image:manipulated', (notification) => {
        const uploadedFile = notification.object.uploadedfile;
        const widget = $(`.widget-webinar[data-poster-file-id="${uploadedFile.id}"]`);
        if (widget.length === 0) {
            return;
        }

        widget.find('.webinar-body').css('background-image', 'none');

        const url = widget.data('poster-image-url');
        real.image.load(url, () => {
            widget.find('.webinar-body').css('background-image', `url("${url}")`);
        });
    });

    real.events.on('widget:webinar:started', (notification) => {
        const webinarActions = livePopoutLayout.find('.live-popout-webinar-actions');
        if (!webinarActions.hasClass('d-none') && livePopoutLayout.data('widget-id') === notification.object.widget.id) {
            webinarActions.find('.start-webinar-btn').addClass('d-none');
            webinarActions.find('.end-webinar-btn').removeClass('d-none');
        }
        const widget = $(`.widget[data-widget-id="${notification.object.widget.id}"]`);
        if (widget.length) {
            howspace.widgets.updateWidget(widget, 'view');
        }
    });

    real.events.on('widget:webinar:ended', (notification) => {
        const widget = $(`.widget[data-widget-id="${notification.object.widget.id}"]`);
        if (!real.events.isFromCurrentUser(notification)) {
            if (livePopoutLayout.data('widget-id') === notification.object.widget.id) {
                howspace.widgets.webinar.leave(widget);
            } else {
                howspace.widgets.updateWidget(widget, 'view');
            }
        } else {
            const webinarActions = livePopoutLayout.find('.live-popout-webinar-actions');
            if (!webinarActions.hasClass('d-none')) {
                webinarActions.find('.end-webinar-btn').addClass('d-none');
                webinarActions.find('.start-webinar-btn').removeClass('d-none');
            }
            if (widget.length) {
                howspace.widgets.updateWidget(widget, 'view');
            }
        }
    });

    const start = (widget) => {
        if (widget.length) {
            widget.removeClass('is-ended');
        }
        const url = widget.length
            ? howspace.widgets.getApiUrl(widget)
            : real.baseUri + '/api/widget/' + livePopoutLayout.data('widget-type') + '/' + livePopoutLayout.data('widget-id');
        real.ajax.json(url, {
            type: 'POST',
            data: JSON.stringify({
                status: 'started',
            }),
            success: (response) => {
                // The websocket will handle the rest.
            },
        });
    };

    const end = (widget) => {
        const url = widget.length
            ? howspace.widgets.getApiUrl(widget)
            : real.baseUri + '/api/widget/' + livePopoutLayout.data('widget-type') + '/' + livePopoutLayout.data('widget-id');
        real.ajax.json(url, {
            type: 'POST',
            data: JSON.stringify({
                status: 'ended',
            }),
            success: (response) => {
                // The websocket will handle the rest.
            },
        });
    };

    const join = (widget, viewAsHost) => {
        const dataPayload = {
            view_as_host: viewAsHost,
        };

        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/state/join', {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: (response) => {
                // Capture before initPopout() overwrites data-widget-topic
                const previousTopic = livePopoutLayout.data('widget-topic');

                howspace.widgets.live.initPopout(widget, response.popout_position, response.embed_code, response.live_active_title);

                if (response.view_as_host) {
                    const webinarActions = livePopoutLayout.find('.live-popout-webinar-actions');
                    webinarActions.removeClass('d-none');
                    if (response.status === 'started') {
                        webinarActions.find('.start-webinar-btn').addClass('d-none');
                        webinarActions.find('.end-webinar-btn').removeClass('d-none');
                    } else {
                        webinarActions.find('.start-webinar-btn').removeClass('d-none');
                        webinarActions.find('.end-webinar-btn').addClass('d-none');
                    }
                }

                real.realtime.subscribe(widget.data('topic'));
                howspace.widgets.updateWidget(widget, 'view');

                if (response.live_previous_widget_id) {
                    if (previousTopic && previousTopic !== widget.data('topic')) {
                        real.realtime.unsubscribe(previousTopic);
                    }
                    const previousWidget = $('#widget-' + response.live_previous_widget_id);
                    if (previousWidget.length > 0) {
                        howspace.widgets.updateWidget(previousWidget, 'view');
                    }
                }

                howspace.activityTracker.setInMeeting(true);
            },
        });
    };

    const leave = widget => {
        const url = (widget.length
            ? howspace.widgets.getApiUrl(widget)
            : real.baseUri + '/api/widget/' + livePopoutLayout.data('widget-type') + '/' + livePopoutLayout.data('widget-id')
        ) + '/state/leave';

        const topic = widget.length ? widget.data('topic') : livePopoutLayout.data('widget-topic');

        real.ajax.json(url, {
            type: 'POST',
            success: () => {
                howspace.widgets.live.destroyPopout();

                real.realtime.unsubscribe(topic);

                if (widget.length) {
                    howspace.widgets.updateWidget(widget, 'view');
                }

                howspace.activityTracker.setInMeeting(false);
            }
        });
    };

    livePopoutLayout.on('click', '.start-webinar-btn', () => {
        start($('#widget-' + livePopoutLayout.attr('data-widget-id')));
    });

    livePopoutLayout.on('click', '.end-webinar-btn', () => {
        end($('#widget-' + livePopoutLayout.attr('data-widget-id')));
    });

    return {
        initView: widget => {
            howspace.widgets.live.initDrag();

            // Join as host button.
            widget.on('click', '.join-as-host-btn', () => {
                join(widget, true);
            });

            // Join as viewer button.
            widget.on('click', '.join-as-viewer-btn', () => {
                join(widget, false);
            });

            // Leave button.
            widget.find('.leave-btn').on('click', () => {
                howspace.widgets.webinar.leave(widget);
            });
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {
            widget.on('click', '.publish-btn', e => {
                const btn = $(e.target);
                const tr = btn.closest('tr');
                const recordingId = tr.data('id');
                const timestamp = tr.find('time').first().text();

                const dataPayload = {
                    widget: {
                        type: 'video',
                        params: {
                            title: howspace.translate('webinar_recording_publish_title', { 'timestamp': timestamp })
                        }
                    }
                };

                const pageId = real.dom.$body.data('page-id');
                const columnId = btn.closest('.column').data('column-id');
                real.ajax.json(`${real.baseUri}/api/page/${pageId}/column/${columnId}/add-widget`, {
                    type: 'POST',
                    data: JSON.stringify(dataPayload),
                    success: response => {
                        real.ajax.json(howspace.widgets.getApiUrl(widget) + '/recording/' + recordingId + '/publish', {
                            type: 'POST',
                            data: JSON.stringify({ workspace: real.dom.$body.data('workspace-id'), video: response.widget.id }),
                        });
                    }
                });
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        join: join,
        leave: leave
    };
})();
